// Avalon — Private Yacht Charter
export const META = { brand: 'Avalon', tagline: 'Maison', est: '1968', motto: 'Twelve hulls. Eighteen captains. One thousand sea miles a season.' };

export const ROUTES = [
  { id: 'home', label: 'Maison' },
  { id: 'fleet', label: 'The Fleet' },
  { id: 'voyage', label: 'A Voyage' },
  { id: 'charter', label: 'Private Charter' },
];

export const STATS = [
  { v: '12', l: 'Hulls in service' },
  { v: '184m', l: 'Largest beam' },
  { v: '£2.4M', l: 'From, per week' },
  { v: '63%', l: 'Repeat charters' },
];

export const PORTS = ['Antibes', 'Saint-Tropez', 'Porto Cervo', 'Bodrum', 'Mykonos', 'Capri', 'Mallorca', 'Saint-Barth'];

export const FLEET = [
  {
    name: 'Avalon I — Aurora', class: 'Sailing', loa: '54.2 m', guests: 12, crew: 9, year: 2018, builder: 'Royal Huisman, Vollenhove',
    rate: 'from £620,000 / week', img: 'https://images.pexels.com/photos/189349/pexels-photo-189349.jpeg?auto=compress&cs=tinysrgb&w=1600',
    highlights: ['Three-deck atrium with spiral staircase', 'Master cabin with private upper terrace', 'Tender garage for two 8 m chase boats'],
  },
  {
    name: 'Avalon IV — Solène', class: 'Motor', loa: '74 m', guests: 14, crew: 18, year: 2022, builder: 'Lürssen, Bremen',
    rate: 'from £1,840,000 / week', img: 'https://images.pexels.com/photos/2820884/pexels-photo-2820884.jpeg?auto=compress&cs=tinysrgb&w=1600',
    highlights: ['Sundeck infinity pool, 14 m', 'Helideck (touch-and-go)', 'Beach club with hammam & gym'],
  },
  {
    name: 'Avalon VII — Atlas', class: 'Explorer', loa: '88 m', guests: 16, crew: 22, year: 2024, builder: 'Damen, Galați',
    rate: 'from £2,400,000 / week', img: 'https://images.pexels.com/photos/1320684/pexels-photo-1320684.jpeg?auto=compress&cs=tinysrgb&w=1600',
    highlights: ['Ice-class 1A — Antarctic-rated', 'Submarine garage (U-Boat Worx C-Researcher)', '21-day autonomy without bunkering'],
  },
];

export const VOYAGE = [
  { day: 'Day 01', port: 'Saint-Tropez', t: '08:30', n: 'Boarding & welcome aperitif on the upper deck. Provisioning from the Marché Forain.' },
  { day: 'Day 02', port: 'Île de Porquerolles', t: '11:00', n: 'Anchor at Plage Notre-Dame. Lunch by the chef ashore. Afternoon tender to the Fort Sainte-Agathe.' },
  { day: 'Day 03', port: 'Calvi', t: '07:00', n: 'Dawn arrival into the citadel bay. Private tour of the Genoese fortress.' },
  { day: 'Day 04', port: 'Bonifacio', t: '14:30', n: 'Evening anchorage off the limestone cliffs. Dinner served on the aft sundeck.' },
  { day: 'Day 05', port: 'La Maddalena', t: '10:00', n: 'Snorkelling at Spargi. Lunch ashore at a private cove arranged with Aldo, our shoreside fixer.' },
  { day: 'Day 06', port: 'Porto Cervo', t: '17:00', n: 'Berth at Marina Piccola for evening. Optional dinner at Il Pescatore.' },
  { day: 'Day 07', port: 'Olbia', t: '09:00', n: 'Disembarkation. Transfer arranged to private aviation terminal.' },
];

export const CREW = [
  { role: 'Captain', name: 'Philippe Adrien', cred: '32 years, MCA Master 3000', portrait: 'https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=600' },
  { role: 'Chef de Cuisine', name: 'Léo Marchant', cred: 'ex-L’Atelier de Joël Robuchon, two Michelin stars', portrait: 'https://images.pexels.com/photos/1239291/pexels-photo-1239291.jpeg?auto=compress&cs=tinysrgb&w=600' },
  { role: 'Purser', name: 'Sophie Rouvier', cred: 'fifteen seasons aboard', portrait: 'https://images.pexels.com/photos/3760263/pexels-photo-3760263.jpeg?auto=compress&cs=tinysrgb&w=600' },
];
